export declare type FilterOptionsType = {
    // Main label to shown for the filter
    label: string;
    // Label key to be shown for each filter option
    optionLabelKey: string;
    // Key to select from filter option to do the filtering
    optionFilterKey: string;
    // Item Key to do the filtering based on the key value
    itemFilterKey: string;
    // Filter options list
    filterOptionsList: any;
    // Selected filter options
    selectedFilterOptions?: string[];
};

export const SET_ADVANCED_CHECKLIST_ITEMS = 'SET_ADVANCED_CHECKLIST_ITEMS';

export function setAdvancedChecklistItems(items: any) {
    return {
        type: SET_ADVANCED_CHECKLIST_ITEMS,
        payload: items,
    };
}

export const SET_ADVANCED_CHECKLIST_FILTERS = 'SET_ADVANCED_CHECKLIST_FILTERS';

export function setAdvancedChecklistFilters(filters: FilterOptionsType[]) {
    console.log(filters, 'filtersfilters');

    return {
        type: SET_ADVANCED_CHECKLIST_FILTERS,
        payload: filters,
    };
}

export const SET_ADVANCED_CHECKLIST_SELECTED_FILTERS = 'SET_ADVANCED_CHECKLIST_SELECTED_FILTERS';

export function setAdvancedChecklistSelectedFilters(selectedFiltersIDs: string[]) {
    return {
        type: SET_ADVANCED_CHECKLIST_SELECTED_FILTERS,
        payload: selectedFiltersIDs,
    };
}
